import moment from 'moment';
import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {addSelectedPackage} from '../../../redux/actions';
import {installmentDiscountBreakdown} from '../../../utility/installmentPricing';
import {installmentsToDisplay} from '../utils';
import PackUI from './PackUI';

const CampPacks = ({
  selectedPackage,
  campPacksList,
  isInst,
  setIsInstallmentPlanSelected,
  hasSquare,
}) => {
  const bookingDetails = useSelector(state => state.booking);
  const {repeat_id, allow_book_individually, one_time_fee, start_branch_time} =
    bookingDetails?.classDetails || {};
  const dispatch = useDispatch();

  const displayInstallments = installmentsToDisplay(selectedPackage?.inst);
  const discountQuote = bookingDetails?.couponCode?.couponDetails?.quote;
  const installmentPrices = installment => {
    const quotedBreakdown = installmentDiscountBreakdown(discountQuote, installment);
    if (quotedBreakdown) {
      return {
        originalPrice: quotedBreakdown.originalAmount.toFixed(2),
        discountedPrice:
          quotedBreakdown.discountAmount > 0 ? quotedBreakdown.finalAmount.toFixed(2) : null,
      };
    }

    const participantCount = bookingDetails?.selectedFamilyMembers?.length || 1;
    const originalPrice = Number(installment?.price || 0) * participantCount;
    const percent = Number(bookingDetails?.couponCode?.couponDetails?.percent || 0);
    const discountedPrice =
      installment?.allowDiscount === true && percent > 0
        ? originalPrice - (originalPrice * percent) / 100
        : null;

    return {
      originalPrice: originalPrice.toFixed(2),
      discountedPrice: discountedPrice === null ? null : discountedPrice.toFixed(2),
    };
  };
  console.log('displayInstallments', displayInstallments);
  const [installmentsmodal, setInstallmentsmodal] = useState(false);
  let instPackages = campPacksList;

  instPackages = campPacksList
    .map((inst, originalIndex) => {
      // Extract first payment price from installments
      const firstInstallment = inst.inst?.installments?.[0];
      const firstPaymentPrice = firstInstallment?.price || 0;

      return {
        ...inst,
        _originalIndex: originalIndex,
        inst: {
          ...inst.inst,
          firstPaymentPrice: firstPaymentPrice,
        },
      };
    })
    .sort((a, b) => {
      const paymentsA = a.inst?.installments?.length || 0;
      const paymentsB = b.inst?.installments?.length || 0;

      if (paymentsA !== paymentsB) {
        return paymentsA - paymentsB;
      }

      // If they have the same number of payments, sort by name alphabetically
      return String(a.inst?.name || '').localeCompare(String(b.inst?.name || ''));
    });
  console.log('instPackages', hasSquare, instPackages);
  if (!hasSquare) {
    instPackages = instPackages.filter(inst => {
      return inst?.inst?.isInstallment === false;
    });
  }
  console.log('bookingDetails', bookingDetails);
  return (
    <>
      {repeat_id && allow_book_individually && !isInst && (
        <>
          <p className="text-dark bg-light text-left pl-3 py-2 my-3 text-dark fw-normal">
            Please select if you would like to book all the days of the event or just the present
            day?
          </p>

          {/* Ensuring equal height columns */}
          <div className="row d-flex align-items-stretch row-cols-1 row-cols-md-4 mb-3 text-center">
            {campPacksList.map(pack => (
              <div className="col-md-4 d-flex align-items-stretch mb-3" key={pack.label}>
                <PackUI
                  {...pack}
                  _handleOnClick={() => dispatch(addSelectedPackage(pack))}
                  isSelected={pack.campBookType === selectedPackage?.campBookType}
                  isShowBookingDate={pack.campBookType === 'single'}
                  bookingDate={moment(start_branch_time).format('MM/DD/YYYY')} // MM/DD/YYYY format
                  coupon={bookingDetails?.couponCode?.couponDetails}
                />
              </div>
            ))}
          </div>

          {one_time_fee && (
            <div className="pl-3">
              <input
                className="form-check-input"
                type="checkbox"
                id={`check1`}
                checked={selectedPackage?.isOneTimeMembershipFeeEnabled}
                onChange={() => {
                  if (!selectedPackage?.price) {
                    toast.error('You need to select at-least one package!');
                    dispatch(
                      addSelectedPackage({
                        ...selectedPackage,
                        isOneTimeMembershipFeeEnabled: false,
                      })
                    );
                    return;
                  }
                  dispatch(
                    addSelectedPackage({
                      ...selectedPackage,
                      isOneTimeMembershipFeeEnabled:
                        !selectedPackage?.isOneTimeMembershipFeeEnabled,
                    })
                  );
                }}
              />
              <p>
                There is a member fee of $ {one_time_fee}, please check this box if you have not
                paid the membership fee yet
              </p>
            </div>
          )}
        </>
      )}

      {!repeat_id && !isInst && (
        <>
          <p className="text-dark bg-light text-left pl-3 py-2 my-3 text-dark fw-normal">
            Packages
          </p>
          <div className="row d-flex align-items-stretch row-cols-1 row-cols-md-4 mb-3 text-center">
            <div className="col-md-4 d-flex align-items-stretch mb-3">
              <PackUI {...selectedPackage} coupon={bookingDetails?.couponCode?.couponDetails} />
            </div>
          </div>
        </>
      )}

      {repeat_id && !allow_book_individually && !isInst && (
        <>
          <p className="text-dark bg-light text-left pl-3 py-2 my-3 text-dark fw-normal">
            All the days of the event will be booked
          </p>
          <div className="row d-flex align-items-stretch row-cols-1 row-cols-md-4 mb-3 text-center">
            <div className="col-md-4 d-flex align-items-stretch mb-3">
              <PackUI {...selectedPackage} coupon={bookingDetails?.couponCode?.couponDetails} />
            </div>
          </div>
        </>
      )}

      {isInst && !instPackages.length && (
        <div className="alert alert-warning mt-3" role="alert">
          No camp packages are available for online purchase. Please contact your coach.
        </div>
      )}

      {isInst && instPackages.length > 0 && (
        <>
          <p className="text-dark bg-light text-left pl-3 py-2 my-3 text-dark fw-normal">
            Please select the package you would like to book
          </p>

          <div className="row d-flex align-items-stretch row-cols-1 row-cols-md-4 mb-3 text-center">
            {instPackages.map(pack => {
              console.log('pack', pack);
              return (
                <div className="col-md-4 d-flex align-items-stretch mb-3" key={pack.label}>
                  <PackUI
                    {...pack}
                    isInst={isInst}
                    _handleOnClick={() => {
                      dispatch(addSelectedPackage(pack));
                      setInstallmentsmodal(true);
                      setIsInstallmentPlanSelected(true);
                    }}
                    isSelected={pack._originalIndex === selectedPackage.id}
                    isShowBookingDate={false}
                    coupon={bookingDetails?.couponCode?.couponDetails}
                    fmCount={bookingDetails?.selectedFamilyMembers?.length ?? 1}
                    // installment plan specific first payment price
                    firstPaymentPrice={pack?.inst?.firstPaymentPrice}
                    // total count of installments
                    installmentCount={pack?.inst?.installments?.length || 0}
                  />
                </div>
              );
            })}
          </div>
          <div className="d-flex align-items-stretch">
            {selectedPackage?.installmentType === 'installment' &&
              displayInstallments?.length > 0 &&
              !installmentsmodal && (
                <>
                  <div
                    role="button"
                    className="card mb-4 rounded-3 shadow-sm selected installment-card"
                  >
                    <div className="card-header py-3 bg-dark">
                      <h4 className="my-0 fw-normal text-white fs-5 pack-card">
                        {selectedPackage?.inst?.name}
                      </h4>
                    </div>
                    <div className="p-3">
                      <br />
                      <div
                        className="font-weight-bold font-size-15"
                        style={{
                          marginBottom: '15px',
                          color: '#555',
                          fontSize: '16px',
                        }}
                      >
                        Following installments will be charged on the <br /> following dates:
                      </div>
                      {displayInstallments?.map((installment, index) => {
                        console.log('installment', installment);
                        const {originalPrice, discountedPrice} = installmentPrices(installment);
                        return (
                          <div
                            key={index}
                            className="font-size-14 lh-lg"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '8px 0',
                              borderBottom: '1px solid #eee',
                              color: '#333',
                            }}
                          >
                            <span>
                              {installment.dt == 'At the time of booking' || installment.dt == null
                                ? installment?.dt
                                : moment(installment.dt).format('MM/DD/YYYY')}
                            </span>
                            {discountedPrice !== null ? (
                              <span>
                                <span
                                  className="text-decoration-line-through text-danger"
                                  style={{marginRight: '8px'}}
                                >
                                  {/* ${installment.price} X {bookingDetails?.selectedFamilyMembers?.length} =  */}
                                  ${originalPrice}
                                </span>
                                <span style={{color: 'green'}}>
                                  {/* ${discountedPrice} X {bookingDetails?.selectedFamilyMembers?.length} =  */}
                                  ${discountedPrice}
                                </span>
                              </span>
                            ) : (
                              <span>
                                {/* ${installment.price} X {bookingDetails?.selectedFamilyMembers?.length} =  */}
                                ${originalPrice}
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              )}
          </div>
          {selectedPackage?.installmentType === 'installment' &&
            displayInstallments?.length > 0 && (
              <Modal show={installmentsmodal} onHide={() => setInstallmentsmodal(false)}>
                <Modal.Header>
                  <h4 className="modal-title">{selectedPackage?.inst?.name}</h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setInstallmentsmodal(false);
                      dispatch(addSelectedPackage(null));
                    }}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <div className="mx-auto" style={{width: '100%'}}>
                    <div className="font-weight-bold font-size-16" style={{marginBottom: '16px'}}>
                      The payment schedule for this package is:
                    </div>
                    {displayInstallments?.map((installment, index) => {
                      console.log('installment33', installment);
                      const {originalPrice, discountedPrice} = installmentPrices(installment);
                      return (
                        <div
                          key={index}
                          className="font-size-14"
                          style={{
                            marginBottom: '8px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '8px 0',
                            borderBottom: '1px solid #e0e0e0',
                            textAlign: 'left',
                          }}
                        >
                          <span>
                            {installment.dt == 'At the time of booking' || installment.dt == null
                              ? installment?.dt
                              : moment(installment.dt).format('MM/DD/YYYY')}
                          </span>
                          {discountedPrice !== null ? (
                            <span>
                              <span
                                className="text-decoration-line-through text-danger"
                                style={{marginRight: '8px'}}
                              >
                                {/* ${installment.price} X {bookingDetails?.selectedFamilyMembers?.length} =  */}
                                ${originalPrice}
                              </span>
                              <span style={{color: 'green'}}>
                                {/* ${discountedPrice} X {bookingDetails?.selectedFamilyMembers?.length} =  */}
                                ${discountedPrice}
                              </span>
                            </span>
                          ) : (
                            <span>
                              {/* ${installment.price} X {bookingDetails?.selectedFamilyMembers?.length} =  */}
                              ${originalPrice}
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <br />
                  <div
                    className="text-center mr-auto ml-auto"
                    style={{display: 'flex', justifyContent: 'center', gap: '15px'}}
                  >
                    <button
                      className="btn btn-outline-danger px-md-5"
                      onClick={() => {
                        setInstallmentsmodal(false);
                        setIsInstallmentPlanSelected(false);
                        dispatch(addSelectedPackage({}));
                      }}
                    >
                      Back
                    </button>
                    {!selectedPackage?.isSelectBtn && (
                      <button
                        type="button"
                        className="btn btn-primary px-5 font-size-15"
                        onClick={() => {
                          dispatch(
                            addSelectedPackage({
                              ...selectedPackage,
                              isSelectBtn: true,
                            })
                          );
                          setInstallmentsmodal(false);
                        }}
                      >
                        {selectedPackage?.isSelectBtn ? 'Installment Plan Selected' : 'Select'}
                      </button>
                    )}
                  </div>
                </Modal.Body>
              </Modal>
            )}
        </>
      )}
    </>
  );
};

export default CampPacks;
